export default [
  { id: "deposit_receipt", name: "Comprovante de depósito" },
  { id: "block_receipt", name: "Comprovante de bloqueio" },
  { id: "court_permit", name: "Alvará" },
  { id: "other", name: "Outro documento" },
];
